<template>
	<div>
		<action-sidebar
			title="Create Template"
			:value="true"
			@close-modal="closeModal"
		>
			<v-layout wrap pa-5>
				<v-flex xs12 mb-3>
					<label>Nombre template
						<v-text-field
							solo
							class="body-1"
							hide-details
							label="Nombre del template"
							required
							v-model="model.name"
							:error="$v.model.name.$error"
						/>
					</label>
				</v-flex>
				<v-flex xs12 mb-3>
					<label>
						Rubro
						<v-select
							solo
							label="Rubro"
							item-text="name"
							item-value="id"
							:items="items"
							v-model="model.item"
							:error="$v.model.item.$error"
						/>
					</label>
				</v-flex>
				<v-flex xs12>
					<label>
						Descripción
						<v-textarea
							solo
							class="body-1"
							height="80"
							hide-details
							label="Descripción"
							no-resize
							v-model="model.description"
							:error="$v.model.description.$error"
						/>
					</label>
				</v-flex>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					:is-loading="$v.$invalid || loading"
					:on-run-service="loading"
					@accept-button-clicked="sendData"
					@cancel-button-clicked="closeModal"
				/>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import { required } from 'vuelidate/lib/validators';

function created() {
	this.loadResource();
}

async function loadResource() {
	const url = `project/${this.codeProject}/items`;
	const { data: items } = await this.$http.get(url);
	({ data: this.items } = items);
}

function closeModal() {
	this.goTo('page-template', { params: { projectId: this.projectId, codeProject: this.codeProject } });
}

async function sendData() {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	const { item, name, description } = this.model;
	const body = {
		codeProject: this.codeProject,
		itemId: item,
		name,
		description,
	};
	this.loading = true;
	try {
		await this.$http.post('distribution-template', body, { headers });
		this.showNotification('Se creó correctamente el template');
		this.closeModal();
	} catch (err) {
		this.showError('Ocurrió un error');
	} finally {
		this.loading = false;
	}
}

function validations() {
	const validation = {
		model: {
			item: {
				required,
			},
			name: {
				required,
			},
			description: {
				required,
			},
		},
	};
	return validation;
}

function data() {
	return {
		loading: false,
		items: [],
		model: {
			item: '',
			name: '',
			description: '',
		},
		companies: [],
	};
}

export default {
	name: 'page-template-clone',
	data,
	components: {
		actionSidebar,
	},
	created,
	methods: {
		closeModal,
		loadResource,
		sendData,
	},
	validations,
	props: {
		projectId: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/template/page-template-clone.vue